import React, { useEffect, useRef } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import useWindowSize from '../../hooks/useWindowSize';

const MyMapComponent = () => {
  const { width: w } = useWindowSize();

  // const width = w > 700 ? '426px' : '333px';
  const height = w > 700 ? '300px' : '195px';

  const center = {
    lat: 6.697716696848404,
    lng: 3.3003501373515487
  };

  const zoom = 16;
  const ref = useRef();

  useEffect(() => {
    if (window.google && 'maps' in window.google) {
      const map = new window.google.maps.Map(ref.current, {
        center,
        zoom
      });

      // Create the marker
      new window.google.maps.Marker({
        position: center,
        map,
        title: 'Innovation Associates Nig. Ltd.'
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.google]);

  return (
    <div className="text-center" ref={ref} style={{ height, width: '100%' }}/>
  );
};

const Spinner = () => {
 return (
   <p>Loading...</p>
 )
};

const InnovationMap = () => {
  const render = (status) => {
    switch (status) {
      case status === Status.LOADING:
        return <Spinner />;
      case status === Status.FAILURE:
        return <Spinner />;
      case status === Status.SUCCESS:
        return <MyMapComponent />;
      default:
        return <MyMapComponent />;
    }
  }

  return (
    <Wrapper apiKey="AIzaSyDXZJmbxufqdXhnz2_exYhkmL60HTCZuCk" render={render} />
  )
};
 
export default InnovationMap;
